class AudioUploadService {
  constructor() {
    this.isVercel = typeof window !== 'undefined' && 
      (window.location.protocol === 'https:' || 
       window.location.hostname.includes('vercel.app') || 
       window.location.hostname.includes('vercel.com') ||
       window.location.hostname.includes('gpreto.space') ||
       window.location.hostname !== 'localhost');
    
    this.apiUrl = this.isVercel 
      ? '/api'  // Vercel Functions
      : 'http://localhost:3001/api';  // Servidor local
    
  }

  // Gerar nome de arquivo único - sempre tentar MP3 primeiro
  generateFileName(mimeType) {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 8);
    
    // Priorizar MP3 sempre que possível
    let extension = 'mp3'; // padrão MP3 para máxima compatibilidade
    
    if (mimeType.includes('mpeg') || mimeType.includes('mp3')) {
      extension = 'mp3';
    } else if (mimeType.includes('wav')) {
      extension = 'wav';
    } else if (mimeType.includes('mp4') || mimeType.includes('m4a')) {
      extension = 'm4a';
    } else if (mimeType.includes('ogg')) {
      extension = 'ogg';
    } else if (mimeType.includes('webm')) {
      extension = 'webm';
    } else if (mimeType.includes('aac')) {
      extension = 'aac';
    }
    
    
    return `audio_${timestamp}_${random}.${extension}`;
  }

  // Upload de áudio via API
  async uploadAudio(audioBlob, productId) {
    try {

      if (!audioBlob) {
        throw new Error('Nenhum arquivo de áudio fornecido');
      }

      if (!audioBlob.type.startsWith('audio/')) {
        throw new Error('Apenas arquivos de áudio são permitidos');
      }

      if (audioBlob.size > 50 * 1024 * 1024) { // 50MB
        throw new Error('Arquivo muito grande. Máximo 50MB permitido.');
      }

      const fileName = this.generateFileName(audioBlob.type);
      const formData = new FormData();
      formData.append('audio', audioBlob);
      formData.append('productId', productId);
      formData.append('fileName', fileName);


      const response = await fetch(`${this.apiUrl}/upload-audio`, {
        method: 'POST',
        body: formData,
        headers: {} // Let browser define Content-Type with boundary
      });


      if (!response.ok) {
        let errorData;
        try {
          const responseText = await response.text();
          if (responseText) {
            errorData = JSON.parse(responseText);
          } else {
            errorData = { error: `HTTP ${response.status}: ${response.statusText}` };
          }
        } catch (parseError) {
          errorData = { error: `HTTP ${response.status}: ${response.statusText}` };
        }
        throw new Error(errorData.error || 'Erro no upload');
      }

      const responseText = await response.text();
      
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        throw new Error('Resposta inválida do servidor');
      }

      return {
        success: true,
        audioUrl: result.audioUrl,
        fileName: result.fileName,
        duration: result.duration
      };

    } catch (error) {
      throw new Error(`Erro no upload: ${error.message}`);
    }
  }

  // Obter URL do áudio (DO Spaces CDN)
  getAudioUrl(fileName) {
    return `https://importacao.sgp1.digitaloceanspaces.com/audio/${fileName}`;
  }

  // Testar upload de áudio
  async testUpload() {
    try {
      
      // Criar um blob de áudio de teste (silêncio)
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const sampleRate = 44100;
      const duration = 1; // 1 segundo
      const length = sampleRate * duration;
      
      const buffer = audioContext.createBuffer(1, length, sampleRate);
      const channelData = buffer.getChannelData(0);
      
      // Preencher com silêncio
      for (let i = 0; i < length; i++) {
        channelData[i] = 0;
      }
      
      // Converter para blob (simulado)
      const testBlob = new Blob(['test audio data'], { type: 'audio/webm' });
      
      const result = await this.uploadAudio(testBlob, 'test');
      
      return result;
    } catch (error) {
      throw error;
    }
  }
}

const audioUploadService = new AudioUploadService();
export default audioUploadService;
